import React from 'react';
import { Typography, Box } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
    fotosContainer: {
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(2),
        marginTop: "1rem",
    },
    fotoThumb: {
        width: 100,
        height: 100,
        objectFit: "cover",
        border: "1px solid #ced4da",
        borderRadius: theme.spacing(0.5),
        cursor: "pointer",
        transition: "transform 0.2s",
        "&:hover": {
            transform: "scale(1.05)",
        },
    },
    noDataText: {
        color: "#6c757d",
        fontStyle: "italic",
    },
});

const EquipamentDetailsImagesContainer = ({
    classes,
    photos = [],
    onPhotoClick,
    currentLanguage
}) => {
    return (
        <Box className={classes.fotosContainer}>
            {photos.length > 0 ? (
                photos.map((foto, index) => (
                    <img
                        key={index}
                        src={foto.nome_arquivo}
                        alt={foto.nome || currentLanguage.bepiService.shared.shared_equip_photo_alt}
                        className={classes.fotoThumb}
                        onClick={() => onPhotoClick(foto.nome_arquivo)}
                    />
                ))
            ) : (
                <Typography className={classes.noDataText}>
                    {currentLanguage.bepiService.shared.shared_equip_no_photos_msg}
                </Typography>
            )}
        </Box>
    );
};

export default withStyles(styles)(EquipamentDetailsImagesContainer);
